import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from './../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { PickDateComponent } from './pick-date.component';
import { PrescribeVaccinationService } from './prescribe-vaccination.service';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { NewDiseasePopupComponent } from '../select-disease/new-disease-popup.component';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { DiseaseVaccineModel } from '../../../models/consultation-process/disease-vaccine.model';
import { PatientVaccineVisit } from '../../../models/consultation/patient.model';
import { SharedService } from '../../../shared/services/share.services';
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'prescribe-vaccination',
  templateUrl: 'prescribe-vaccination.component.html',
  providers: [PrescribeVaccinationService]
})

export class PrescribeVaccinationComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
  public appMessages = AppMessages;
  public dateChosen = 'Click me';
  public dateLength = 6;
  public tripInfo: any = {
    country: '',
    departureDate: 0,
    returnDate: 0,
  };
  public diseaseVaccines: Array<DiseaseVaccineModel> = [];
  public courses: Array<any> = []; // default data array for course
  public dateRange: Array<any> = [];
  public defaultDateList: Array<any> = []; // init select box from 7 , 364 days
  public appConstants = AppConstants;
  public date = null;
  public isEditMode = false;
  public patientVaccineVisit = PatientVaccineVisit;
  public storePrescribeArr = [];

  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    public utility: Utility,
    public prescribeVaccinationService: PrescribeVaccinationService,
    private sharedService: SharedService) {
    super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.PrescribeVaccination);
    // get data entry service
    this.sharedService.getDataEntryUpdate().subscribe(
      data => {
        this.updateDataEntryMode(data);
      });
  }

  ngOnInit() {
    this.isDataEntryMode = this.isInDataEntryMode();
    this.isEditMode = this.activeRouter.snapshot.queryParams['isEdit'] || false;
    this.initTripInfo();
    this.initDiseaseVaccineList();
    this.initCourseList();
    this.initDefaultDateList();
  
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  initDiseaseVaccineList() {
    this.prescribeVaccinationService.getPrescribeVaccinationList(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          this.diseaseVaccines = result.json();
          let coveredDate;
          // add orginal vaccineId to open message when change vaccine
          for (let i = 0; i < this.diseaseVaccines.length; i++) {
            this.diseaseVaccines[i].vaccine['orginalVaccineId'] = this.diseaseVaccines[i].vaccine['vaccineId'];
            coveredDate = '';
            if (this.diseaseVaccines[i].vaccine['isCovered']) {
              coveredDate = 'Covered left – ' + this.utility.convertDateToLocalString(new Date(this.diseaseVaccines[i].vaccine['expectedCoverDate']), 'DD MMM YYYY');
            }
            this.diseaseVaccines[i].vaccine['tooltip'] = coveredDate;
            this.diseaseVaccines[i]['isDisableRemove'] = this.isEditMode;
          }
          if (this.diseaseVaccines.length > 0) {
            this.dateRange = this.createVaccineDateRange(this.diseaseVaccines[0].vaccine.vaccineDates, true);
          } else {
            this.dateRange = this.createVaccineDateRange(this.prescribeVaccinationService.getDateRangeList());
          }
          // store vaccine to reuse (SD10001680-346)
          this.storePrescribeArr = JSON.parse(JSON.stringify(this.diseaseVaccines));
        }
      }
    );

  }

  createVaccineDateRange(dateArr, isUpdate = false) {
    let dateRange = [];
    let date;
    for (let i = 0; i < dateArr.length; i++) {
      date = (dateArr[i].visitDate) ? new Date(dateArr[i].visitDate) : null; //this.utility.convertTimeStampToDate(dateArr[i].date);
      dateRange.push({
        'date': this.utility.convertDateToUTCString(date),
        'isDisable': dateArr[i].visit === PatientVaccineVisit.Past
      });
      if (isUpdate === true && date) {
        dateArr[i].date = this.utility.convertDateToTimeStamp(date);
      }
    }
    return dateRange;
  }

  initCourseList() {
    this.prescribeVaccinationService.getCourseList().subscribe(
      (result) => {
        if (result) {
          this.courses = result.json();
        }
      }
    );
  }

  initDefaultDateList() {
    this.defaultDateList = this.prescribeVaccinationService.getDefaultDateList();
  }

  onRemoveDiseaseVaccine(id: string) {
    this.prescribeVaccinationService.removePrescribeVaccination(this.filterParam.id, id).subscribe(
      (result) => {
        if (result) {
          this.diseaseVaccines = this.diseaseVaccines.filter(item => item.id !== id);
        }
      }
    );
    //this.diseaseVaccines = this.diseaseVaccines.filter(item => item.id !== id);
  }

  onChangeVaccineDate(item, index, event) {
    // check if user check on vaccine date but the date is null
    /* if (item.date == null) {
      this.dialogService.openErrorDialog({ message: Utility.stringFormat(AppMessages.prescribeVaccine.errorCheckDate, [index + 1]) }).subscribe(result => {
        if (result) {
          item.isChecked = !event.checked;
        }
      });
    } */
  }


  isShowRemove(vaccineDates, patientVaccineVisit){
     for (let i = 0 ; i < vaccineDates.length; i ++){
       if(vaccineDates[i].isChecked && vaccineDates[i].visit==patientVaccineVisit.Past){
         return false;
       }
     }
     return true;
   }

  getDiseaseName(diseaseArr) {
    let name = '';
    for (let i = 0; i < diseaseArr.length; i++) {
      name += i === 0 ? diseaseArr[i].diseaseName : ', ' + diseaseArr[i].diseaseName;
    }
    return name;
  }

  /**
   * clear date in date range and diseaseVaccines
   * @param dateItem
   * @param index
   */
  onClearDateOnRange(dateItem, index) {
    dateItem.date = null;
    // set new date to diseaseVaccines array
    this.updateVaccineDates(dateItem.date, index);
  }
  /**
   * update dateRange and diseaseVaccines at index with new value when user select on date select box
   * @param dateItem :
   * @param value : array of days number needed to add 7, 14, ...364
   * @param index : index of array needed to be update
   */
  onChangeDate(dateItem, value, index) {
    // update dateRange item
 
    dateItem.date = new Date();
    dateItem.date.setHours(0, 0, 0);
    dateItem.date.setDate(dateItem.date.getDate() + parseInt(value));
    // set new date to diseaseVaccines array
    this.updateVaccineDates(dateItem.date, index);
  }

  /**
   *  update date in diseaseVaccines list. If index > diseaseVaccines length then push new object
   * @param index string : index of date need to update
   * @param date Date : new date need to overwrite old date
   */
  updateVaccineDates(date, index) {
    let timestamp = null;
    if (date) {
      //date.setHours(0, 0, 0);
      timestamp = this.utility.convertDateToTimeStamp(date);
      // User can select the past date in Prescribe Vaccination page. Except in dât entry mode
      if (!this.isDataEntryMode) {
        let curentDate = new Date();
        curentDate.setHours(0, 0, 0);
        if (timestamp < this.utility.convertDateToTimeStamp(curentDate)) {
          this.dialogService.openErrorDialog({ message: Utility.stringFormat(AppMessages.prescribeVaccine.errorPastDate, [index + 1]) });       
          // return false;
        }
      }
    }
    // add new item to dateRange
    if (index >= this.dateRange.length) {
      this.dateRange.push({ date: null, isDisable: false });
    } else {
      this.dateRange[index].date = this.utility.convertTimeStampToDate(timestamp);
    }
    // add new item or update item to diseaseVaccines
    for (let i = 0; i < this.diseaseVaccines.length; i++) {
      if (index >= this.diseaseVaccines[i].vaccine.vaccineDates.length) {
        this.diseaseVaccines[i].vaccine.vaccineDates.push({ isChecked: false, isDisable: false, date: timestamp });
        this.diseaseVaccines[i].vaccine.vaccineDates[index].visitIndex = index + 1;

        // update store prescribe vaccine
        // this.storePrescribeArr[i].vaccine.vaccineDates.push({ isChecked: false, date: timestamp });
      } else {
        this.diseaseVaccines[i].vaccine.vaccineDates[index].date = timestamp;
        this.diseaseVaccines[i].vaccine.vaccineDates[index].visitDate = this.utility.convertDateToString(date);
        this.diseaseVaccines[i].vaccine.vaccineDates[index].visitIndex = index + 1;

        // update store prescribe vaccine
        //this.storePrescribeArr[i].vaccine.vaccineDates[index].date = timestamp;
        // this.storePrescribeArr[i].vaccine.vaccineDates[index].visitDate = this.utility.convertDateToUTCString(date);
      }
    }
  }

  /**
   * add new date in dateRange array and vaccineDates of diseaseVaccines
   */
  onAddDateOnRange() {
    this.updateVaccineDates(null, this.dateRange.length);
  }

  /**
   * remove date in dateRange array and vaccineDates of diseaseVaccines
   * @param index string
   */
  onRemoveDateOnRange(index) {
    if (index > this.dateRange.length) {
      return;
    } else {
      this.dateRange.splice(index, 1);
    }
    // remove item from diseaseVaccines and dateRange
    for (let i = 0; i < this.diseaseVaccines.length; i++) {
      this.diseaseVaccines[i].vaccine.vaccineDates.splice(index, 1);
    }
  }

  /**
   * count the number of date was checked
   * @param vaccineDates : date array of object { isChecked: true, date: 1413173580}
   */
  getCheckDateNumber(vaccineDates) {
    let count = 0;
    for (let i = 0; i < vaccineDates.length; i++) {
      if (vaccineDates[i].isChecked === true) {
        count++;
      }
    }
    return count;
  }

  /**
   * function to add new disease to list
   * @param diseaseArr Array : array of disease which user is select
   */
  addNewDiseaseToList(diseaseArr) {
    this.prescribeVaccinationService.getNewAddPrescribeVaccinationOfDisease(this.filterParam.id, diseaseArr).subscribe(
      (result) => {
        if (result) {
          let data = result.json();
          let vaccineDates: Array<any> = [];
          let item;
          // init vaccineDates for new disease item
          for (let i = 0; i < this.dateRange.length; i++) {
            if (this.diseaseVaccines.length > 0) {
              item = JSON.parse(JSON.stringify(this.diseaseVaccines[0].vaccine.vaccineDates[i]));
            } else {
              item = data[0].vaccine.vaccineDates[0];
              item['date'] = this.dateRange[i].date !== null ? this.utility.convertDateToTimeStamp(this.dateRange[i].date) : null;
            }
            item['isChecked'] = false;
            vaccineDates.push(JSON.parse(JSON.stringify(item)));
          }
          // push new disease to this.diseaseVaccines list
          for (let i = 0; i < data.length; i++) {
            data[i].vaccine.vaccineDates = JSON.parse(JSON.stringify(vaccineDates));
            data[i]['isDisableRemove'] = false;
            this.diseaseVaccines.push(data[i]);
          }
        }
      }
    );

  }

  /**
   * open add new diseases popup and add new disease to this.diseaseVaccines
   */
  onOpenNewDiseaseDialog() {
    const data = {
      consultationId: this.filterParam.id
    };
    this.dialogService.openComponentDialog(NewDiseasePopupComponent, data, {
      width: '450px', position:
        { top: this.getTopPosition() + 'px' }
    }).subscribe(result => {
      if (result !== null && result.length > 0) {
        this.addNewDiseaseToList(result);
      }
    });
  }

  /**
  * return true if List of visit dates must be ordered in ascending
   * @param vaccineDates visit date array
   */
  isVisitDateAccending(vaccineDates) {
    for (let i = 0; i < vaccineDates.length - 1; i++) {
      if (vaccineDates[i].date !== null && vaccineDates[i + 1].date !== null && vaccineDates[i].date >= vaccineDates[i + 1].date) {
        return false;
      }
    }
    return true;
  }

  /**
   * return true if date array match rules below:
   * 1: The no of administer must be more than 0, otherwise display error message
   * 2: The number of visit date must match with the number of administer.
   * 3: List of visit dates must be ordered in ascending
   */
  isDataValid() {
    let vaccineNum;
    for (let i = 0; i < this.diseaseVaccines.length; i++) {
      // check if vaccine is checked but the date is not filled
      for (let j = 0; j < this.diseaseVaccines[i].vaccine.vaccineDates.length; j++) {
        if (this.diseaseVaccines[i].vaccine.vaccineDates[j].isChecked && this.diseaseVaccines[i].vaccine.vaccineDates[j].date === null) {
          this.dialogService.openErrorDialog({ message: Utility.stringFormat(AppMessages.prescribeVaccine.errorCheckDate, [j + 1]) });
          return false;
        }
        // User can select the past date in Prescribe Vaccination page. Except in dât entry mode
        if (!this.isDataEntryMode) {
          let curentDate = new Date();
          curentDate.setHours(0, 0, 0);
          if (this.diseaseVaccines[i].vaccine.vaccineDates[j].date 
              && (this.diseaseVaccines[i].vaccine.vaccineDates[j].date < this.utility.convertDateToTimeStamp(curentDate)
               && this.diseaseVaccines[i]['isDisableRemove'] == false) )
              {
               if ((this.diseaseVaccines[i].vaccine.vaccineDates[j].hasOwnProperty('visit') 
                   && this.diseaseVaccines[i].vaccine.vaccineDates[j].visit >= PatientVaccineVisit.Current)
                  || !this.diseaseVaccines[i].vaccine.vaccineDates[j].hasOwnProperty('visit')) 
                {
                 this.dialogService.openErrorDialog({ message: Utility.stringFormat(AppMessages.prescribeVaccine.errorPastDate, [j + 1]) });
                // alert(this.diseaseVaccines[i].vaccine.vaccineDates[j].visit);
                 return false;
                }
             }
        }
      }

      vaccineNum = Number(this.diseaseVaccines[i].vaccine.noOfAdminister);
      // The no of administer must be more than 0, otherwise display error message
      if (vaccineNum <= 0) {
        this.dialogService.openErrorDialog({ message: AppMessages.prescribeVaccine.errorNumberOfVaccine });
        return false;
      }
      // The number of visit date must match with the number of administer.
      if (vaccineNum !== this.getCheckDateNumber(this.diseaseVaccines[i].vaccine.vaccineDates)) {
        this.dialogService.openErrorDialog({ message: AppMessages.prescribeVaccine.errorMacthDate });
        return false;
      }
      // List of visit dates must be ordered in ascending
      if (this.isVisitDateAccending(this.diseaseVaccines[i].vaccine.vaccineDates) === false) {
        this.dialogService.openErrorDialog({ message: AppMessages.prescribeVaccine.errorVisitDateAccending });
        return false;
      }



    }
    return true;
  }

  /**
   * When selecting other vaccine, update list of the disease names
   * @param vaccineId String : new vaccine id
   * @param item Object : diseaseVaccines item
   */
  onChangeVaccine(item, event, index) {
    const vaccineId = event;
    // if vaccineId is exist in list then show error mesage
    for (let i = 0; i < this.diseaseVaccines.length; i++) {
      if (this.diseaseVaccines[i].vaccine.vaccineId === vaccineId && i !== index) {
        const vaccine = item.vaccine.vaccines.filter(v => v.id === vaccineId);
        this.dialogService.openErrorDialog({ message: Utility.stringFormat(AppMessages.prescribeVaccine.errorSelectVaccine, [vaccine[0].name]) });
        item.vaccine.vaccineId = item.vaccine.orginalVaccineId;
        return item.vaccine.vaccineId;
      }
    }
    item.vaccine.orginalVaccineId = vaccineId;
    //item.diseases = this.prescribeVaccinationService.getDiseaseByVaccine(vaccineId);
    this.prescribeVaccinationService.getDiseaseByVaccine(this.filterParam.id, vaccineId, item.vaccine.diseaseId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          item.diseases = data.diseases;
          item.vaccine.noOfAdminister = data.vaccine.noOfAdminister;
          item.vaccine.courseId = data.vaccine.courseId;
          item.vaccine.isHighLight = data.vaccine.isHighLight;
          item.vaccine.isWarning = data.vaccine.isWarning;
          item.vaccine.vaccineId = data.vaccine.vaccineId;
          item.vaccine.vaccineName = data.vaccine.vaccineName;
          item.vaccine.age = data.vaccine.age;
          item.vaccine.warningText = data.vaccine.warningText;
          item.vaccine.medicalCondition = data.vaccine.medicalCondition;
          item.vaccine.vaccines = data.vaccine.vaccines;
          // update store (SD10001680-346)
          this.onStoreVaccine(item);
          return item.vaccine.vaccineId;
        }
      }
    );
  }


  /**
   * save data when user click on next/prev/other step
   */
  submitData() {
    if (this.isMoveNextStep && this.isDataValid()) {
      // call API to save data
      this.prescribeVaccinationService.updatePrescribeVaccination(this.filterParam.id, this.diseaseVaccines, this.isMoveNextStep).subscribe(
        (result) => {
          // move to another step
          this.navigateAction();
        }
      );
    } else if(!this.isMoveNextStep) {
      this.navigateAction();
    }
  }

  /**
    * over write redirect to another step in consultation
    */
  navigateAction() {
    if (this.filterParam.patientId) {
      // When selecting on “Next step” in Prescribe Vaccination(s) page, move to Administer vaccine page
      if (this.isMoveNextStep === true && this.lastedStep === ConsultationStep.AdministerVaccination) {
        this.router.navigate(['consultation-process/administer-vaccine', this.filterParam.id, this.filterParam.patientId]);
      } else {
        this.router.navigate([this.navigateUrl, this.filterParam.id, this.filterParam.patientId]);
      }
    } else {
      this.router.navigate([this.navigateUrl, this.filterParam.id]);
    }
  }

  onSelectCourse(event, item) {
    const vaccineId = item.vaccine.vaccineId;
    const courseId = event.target.value;
    this.prescribeVaccinationService.getNoOfAdminister(courseId, vaccineId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          item.vaccine.noOfAdminister = data['administerNumber'];
        }
      });
  }

  /**
   * update isDataEntryMode flag
   * @param dataEntryMode : 0/1
   */
  updateDataEntryMode(dataEntryMode) {
    this.isDataEntryMode = (dataEntryMode === 1) ? true : false;
  }
  /**
  * check if step is in add or edit mode
  * over write in base component
  */
  updateEditMode() {
    if (this.lastedStep >= ConsultationStep.AdministerVaccination) {
      this.isEditMode = true;
    }
  }

  /**
   * function to check if in edit mode then store old vacccine to backup (bug SD10001680-346)
   */
  onStoreVaccine(prescribe) {
    if (!this.isEditMode || !prescribe['isDisableRemove']) {
      return;
    }
    const storeIndex = this.storePrescribeArr.findIndex(item => item.id === prescribe.id);
    if (storeIndex >= 0) {
      const vaccine = this.storePrescribeArr[storeIndex];
      if (prescribe.vaccine.vaccineId === this.storePrescribeArr[storeIndex].vaccine.vaccineId) {
        // user changes back to Vaccine instore
        prescribe.vaccine.vaccineDates = JSON.parse(JSON.stringify(this.storePrescribeArr[storeIndex].vaccine.vaccineDates));
      } else {
        // uncheck on vaccineDates
        prescribe.vaccine.vaccineDates.forEach(item => {
          item.isChecked = false;
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/prescribe-vaccination/prescribe-vaccination.component.ts